export enum ConfDialogType {
  CONFIRM,
  MESSAGE
}

export class ConfirmDialogModel {
  constructor(public title: string, public message: string, public type: ConfDialogType = ConfDialogType.CONFIRM) {
  }
}
